// imports
import clsx from 'clsx';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ICON } from '../../../assets';
import { LINKS, ROUTES } from '../../../constants';
import { IActionItem } from '../../../common/types';
import Dropdown from '../../../atoms/dropdown/sidebar';

// interfaces / types / consts
const NAV_ITEMS: IActionItem[] = [
  {
    key: 'inventory',
    icon: ICON.ACCOUNT_BRIEFCASE,
    iconActive: ICON.ACCOUNT_BRIEFCASE_ACTIVE,
    children: [
      { key: 'heroes', url: ROUTES.HERO_COLLECTION },
      { key: 'items', url: ROUTES.ITEM_COLLECTION }
    ]
  },
  {
    key: 'activity', url: ROUTES.ACTIVITY, icon: ICON.ACCOUNT_ACTIVITY, iconActive: ICON.ACCOUNT_ACTIVITY_ACTIVE
  },
  {
    key: 'settings', display: 'account settings', url: ROUTES.SETTINGS, icon: ICON.ACCOUNT_SETTINGS, iconActive: ICON.ACCOUNT_SETTINGS_ACTIVE
  },
  {
    key: 'help', url: LINKS.GIT_BOOK, icon: ICON.ACCOUNT_INFO
  }];

// exports
export default function AccountTabView(): JSX.Element {
  // hooks configuration
  const location = useLocation();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(location.pathname.split('/')[2]);
  // private methods
  const onItemClicked = (url: string, key: string): void => {
    navigate(url);
    setCurrentTab(key);
  };
  // render
  return (
    <div className="account-tab-view">
      <ul>
        {NAV_ITEMS.map((navItem) => {
          const {
            key, url, display, icon, iconActive, children
          } = navItem;
          const isActive = key === currentTab;
          return (children
            ? (<Dropdown key={key} item={navItem} currentTab={currentTab} onItemClicked={onItemClicked} />)
            : (
              <li key={key} className={clsx(isActive && 'active')}>
                <button
                  type="button"
                  onClick={() => {
                    if (url) {
                      if (url.includes('http')) { window.open(url, '_blank', 'noreferrer'); } else { onItemClicked(url, key); }
                    }
                  }}
                >
                  <div className="li-container">
                    <img src={isActive ? iconActive : icon} alt="icon" />
                    <div className="li-text">
                      {display || key}
                    </div>
                  </div>
                </button>
              </li>
            ));
        })}
      </ul>
      <div className="navigator-footer">{`Version ${process.env.REACT_APP_VERSION}`}</div>
    </div>
  );
}
